import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import RichCustomChatMessageDto from "@/models/messages/RichCustomChatMessageDto";
import "./ChatForwardMessageItem.scss";
import { convertTextToEmojiHtml } from "@/common/emojis";
import { assert } from "@/common/assert";
import { showChatRecordModal } from "./components/ChatRecordModal";
var NAMESPACED_CLICK_EVENT_NAME = "click.fht360.chatforward";

var ChatForwardMessageItem =
/** @class */
function (_super) {
  __extends(ChatForwardMessageItem, _super);

  function ChatForwardMessageItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.myRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  ChatForwardMessageItem.prototype.componentDidMount = function () {
    var _this = this;

    var el = this.myRef.current;
    assert(el, "el must be there");
    $(el).on(NAMESPACED_CLICK_EVENT_NAME, function (e) {
      return _this.onClickForwardMessage(_this.props.message);
    });
  };

  ChatForwardMessageItem.prototype.componentWillUnmount = function () {
    var el = this.myRef.current;
    assert(el, "el must be there");
    $(el).off(NAMESPACED_CLICK_EVENT_NAME);
  };

  ChatForwardMessageItem.prototype.onClickForwardMessage = function (message) {
    showChatRecordModal(message);
  };

  ChatForwardMessageItem.prototype.render = function () {
    var m = this.props.message;
    assert(m instanceof RichCustomChatMessageDto, "m not RichCustomChat");
    var attrs = m.customAttrs;
    var html = convertTextToEmojiHtml(attrs.Description);
    var r = html.replace(/\r\n|\r|\n/g, "<br />");
    return _jsxs("div", __assign({
      className: "forward-message-item",
      ref: this.myRef
    }, {
      children: [_jsxs("p", __assign({
        className: "forward-message-item__title"
      }, {
        children: [attrs.Info.UserName, "\u7684\u804A\u5929\u8BB0\u5F55"]
      }), void 0), _jsx("ul", __assign({
        className: "forward-list"
      }, {
        children: _jsxs("li", __assign({
          className: "forward-list__item"
        }, {
          children: [_jsx("p", {
            className: "forward-list__item-content",
            dangerouslySetInnerHTML: {
              __html: r
            }
          }, void 0), _jsxs("p", __assign({
            className: "forward-list__item-note"
          }, {
            children: ["\u70B9\u51FB\u67E5\u770B", attrs.Messages.length, "\u6761\u8F6C\u53D1\u6D88\u606F"]
          }), void 0)]
        }), this.props.message.id)
      }), void 0)]
    }), void 0);
  };

  return ChatForwardMessageItem;
}(React.Component);

export default ChatForwardMessageItem;